<template>
  <div class="flex justify-center text-center w-[100%] absolute bottom-[7vh] z-[10] ">
    <div class="w-[160] cursor-pointer" @click="push({ path: '/' })">
      <p class="w-[48] h-[48] mx-[auto] bg-[rgba(255,255,255,0.90)] rounded-[100]">
        <svg class="icon-svg h-[48]  t-[30]" aria-hidden="true">
          <use xlink:href="#icon-a-1-012"></use>
        </svg>
      </p>
      <p class="pt-[16]">主页</p>
    </div>
    <div class="w-[160] cursor-pointer" @click="push({ path: '/receipt' })">
      <p class="w-[48] h-[48] mx-[auto] bg-[rgba(255,255,255,0.90)] rounded-[100]">
        <svg class="icon-svg  h-[48]  t-[30]" aria-hidden="true">
          <use xlink:href="#icon-a-5-011"></use>
        </svg>
      </p>
      <p class="pt-[16]">应收账款融资</p>
    </div>
    <div class="w-[160] cursor-pointer" @click="push({ path: '/payment' })">
      <p class="w-[48] h-[48] mx-[auto] bg-[rgba(255,255,255,0.90)] rounded-[100]">
        <svg class="icon-svg h-[48]  t-[30]" aria-hidden="true">
          <use xlink:href="#icon-a-4-011"></use>
        </svg>
      </p>
      <p class="pt-[16]">预付款融资</p>
    </div>
    <div class="w-[160] cursor-pointer" @click="push({ path: '/repertory' })">
      <p class="w-[48] h-[48] mx-[auto] bg-[rgba(255,255,255,0.90)] rounded-[100]">
        <svg class="icon-svg h-[48] t-[30]" aria-hidden="true">
          <use xlink:href="#icon-a-3-011"></use>
        </svg>
      </p>
      <p class="pt-[16]">存货融资</p>
    </div>
    <div class="w-[160] cursor-pointer" @click="push({ path: '/diff' })">
      <p class="w-[48] h-[48] mx-[auto] bg-[rgba(255,255,255,0.90)] rounded-[100]">
        <svg class="icon-svg h-[48] t-[30]" aria-hidden="true">
          <use xlink:href="#icon-a-2-012"></use>
        </svg>
      </p>
      <p class="pt-[16]">对比</p>
    </div>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  name: "dg-finance-nav",
  props: {
    index: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {}
  },
  methods: {},
  mounted() { },
  created() { },
}
</script>
<style scoped></style>
 <style>.w-\[100\%\] {
    width: 100%
}
.bottom-\[7vh\] {
    bottom: 7vh
}
.z-\[10\] {
    z-index: 10
}
.w-\[160\] {
    width: 160px
}
.w-\[48\] {
    width: 48px
}
.h-\[48\] {
    height: 48px
}
.mx-\[auto\] {
    margin-left: auto;
    margin-right: auto
}
.bg-\[rgba\(255\,255\,255\,0\.90\)\] {
    background-color: rgba(255,255,255,0.90)
}
.rounded-\[100\] {
    border-radius: 100px
}
.t-\[30\] {
    font-size: 30px
}
.pt-\[16\] {
    padding-top: 16px
}
.flex {
    display: flex
}
.justify-center {
    justify-content: center
}
.text-center {
    text-align: center
}
.absolute {
    position: absolute
}
.cursor-pointer {
    cursor: pointer
}</style>